if (!customElements.get('s-store-page-banner')) {
  customElements.define(
    's-store-page-banner',
    class SectionStorePageBanner extends HTMLElement {
      connectedCallback() {
        this.covers1 = this.querySelectorAll('.store-page-image-1');
        this.covers2 = this.querySelectorAll('.store-page-image-2');
        this.covers3 = this.querySelectorAll('.store-page-image-3');

        if (!this.covers1.length && !this.covers2.length && !this.covers3.length) return;

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll, { passive: true });
        this.handleScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
        this.resetTransforms();
      }

      handleScroll = () => {
        const scrollOffset = Math.max(0, -this.getBoundingClientRect().top);

        this.covers1.forEach((el) => {
          el.style.transform = `rotate(-4.633deg) translateY(${0.3 * scrollOffset}px)`;
        });

        this.covers2.forEach((el) => {
          el.style.transform = `rotate(-10.013deg) translateY(${0.4 * scrollOffset}px)`;
        });

        this.covers3.forEach((el) => {
          el.style.transform = `rotate(14.263deg) translateY(${0.5 * scrollOffset}px)`;
        });
      };

      resetTransforms() {
        this.covers1?.forEach((el) => {
          el.style.transform = 'rotate(-4.633deg)';
        });

        this.covers2?.forEach((el) => {
          el.style.transform = 'rotate(-10.013deg)';
        });

        this.covers3?.forEach((el) => {
          el.style.transform = 'rotate(14.263deg)';
        });
      }
    }
  );
}
